import { useMutation as s } from "@apollo/client";
import i from "../../graphql/mutation/confirmTransaction.js";
import { ApiContextOptions as m } from "../../../temp-lib/constants/apollo.js";
import { useCallback as p } from "react";
const g = () => {
  const [t, { loading: e }] = s(i);
  return {
    mutate: p(
      async (a) => {
        var o, r, n;
        return ((n = (r = (o = (await t({
          context: {
            [m.SkipError]: !0
          },
          variables: {
            txnHash: a
          }
        })).data) == null ? void 0 : o.confirmTxn) == null ? void 0 : r.txnResult) == null ? void 0 : n.length) > 0;
      },
      [t]
    ),
    loading: e
  };
};
export {
  g as default
};
//# sourceMappingURL=useConfirmTransaction.js.map
